import api from './api';

/**
 * Admin authentication service
 */
const adminService = {
  /**
   * Validate admin passkey
   * @param {string} passkey - Admin passkey
   * @returns {Promise<Object>} - Response with token if valid
   */
  validatePasskey: async (passkey) => {
    try {
      const response = await api.post('/admin/validate', { passkey });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || 
        'Authentication failed'
      );
    }
  },

  /**
   * Check if admin is authenticated
   * @returns {Promise<Object>} - Response with admin info if authenticated
   */
  checkAuth: async () => {
    try {
      // Get token from session storage
      const token = sessionStorage.getItem('adminAuth');
      
      if (!token) {
        throw new Error('No authentication token found');
      }

      // Set authorization header
      const response = await api.get('/admin/check-auth', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || 
        'Authentication check failed'
      );
    }
  },

  /**
   * Logout admin by removing token
   */
  logout: () => {
    sessionStorage.removeItem('adminAuth');
  },

  /**
   * Check if admin is logged in
   * @returns {boolean} - True if admin is logged in
   */
  isLoggedIn: () => {
    return sessionStorage.getItem('adminAuth') !== null;
  }
};

export default adminService;
